import React from 'react';
import Styles from '../../../../../stylesheet/css/header-builder/icons/play.css';

const Play = (props) => (
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="16px" height="16px" viewBox="0 0 16 16" xmlSpace="preserve" fill="#d8d5d4">
    <g>
      <g>
        <path className="st0" d="M8,0C3.6,0,0,3.6,0,8s3.6,8,8,8s8-3.6,8-8S12.4,0,8,0z M8,14c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6 S11.3,14,8,14z M6.3,11l5-3l-5-3V11z"/>
      </g>
    </g>
  </svg>
);

export default Play;


// WEBPACK FOOTER //
// ./app/header-builder/components/icons/Play.js